import {AbstractControl, FormControl} from '@angular/forms';
import {
  AlarmRuleConditionHasAlarmCheckTypeConfig,
  AlarmRuleConditionType,
} from '../../../../../../../types/dtos/alarm-rule-condition.dto';
import {AlarmRuleConditionFormDto} from '../../../../../../../types/dtos/alarm-rule.dto';
import {BaseRuleCondition} from '../base-rule-condition';
import {HasAlarmCheck} from './has-alarm-check';


export class HasAlarmCheckRuleCondition extends BaseRuleCondition {
  public getDescription(): string {
    return 'common.alarm-rule.condition.has-alarm-check.description';
  }

  public getIcon(): string {
    return 'alarm_on';
  }

  public getName(): string {
    return 'common.alarm-rule.condition.has-alarm-check.title';
  }

  public getType(): AlarmRuleConditionType {
    return AlarmRuleConditionType.HAS_ALARM_CHECK;
  }

  public getEditorComponent(): any {
    return HasAlarmCheck;
  }

  public override configToFrom(data: AlarmRuleConditionHasAlarmCheckTypeConfig): Record<string, unknown> {
    return {
      exists: data.exists ? 'true' : 'false',
      alarmType: data.alarmType,
    };
  }

  public formToConfig(form: AlarmRuleConditionFormDto): AlarmRuleConditionHasAlarmCheckTypeConfig {
    return {
      exists: form.exists === 'true',
      alarmType: form.alarmType ?? undefined,
    };
  }

  public getFromControls(): Record<string, AbstractControl> {
    return {
      exists: new FormControl(),
      alarmType: new FormControl(),
    };
  }
}
